import React from 'react'

class FacebookUser extends React.Component {
	render() {
		let fb_user_icon = `https://graph.facebook.com/v3.2/${this.props.fb_uid}/picture?width=200&height=200`;
		return <div>
			<p>{this.props.fb_username}</p>
			<img src={fb_user_icon} alt=""/>
		</div>
	}
}

export default FacebookUser


// WEBPACK FOOTER //
// ./app/components/security/facebook/FacebookUser.js